<template>
  <div class="c--input_single-otp-input" style="display: flex; align-items: center">
    <input
      ref="input"
      :type="inputType"
      :inputmode="inputMode"
      min="0"
      max="9"
      pattern="[0-9]"
      data-testid="verification-code-input"
      v-model="model"
      v-upper
      :class="inputClasses"
      @input="handleOnChange"
      @keydown="handleOnKeyDown"
      @paste="handleOnPaste"
      @focus="handleOnFocus"
      @blur="handleOnBlur"
    />
    <span v-if="!isLastChild && separator">
      <span v-html="separator"></span>
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
      },
      separator: {
        type: String,
      },
      focus: {
        type: Boolean,
      },
      inputClasses: {
        type: [String, Array],
      },
      shouldAutoFocus: {
        type: Boolean,
      },
      inputType: {
        type: String,
        required: false,
        default: 'text',
      },
      inputMode: {
        type: String,

        default() {
          return 'text'
        },
      },
      isLastChild: {
        type: Boolean,
      },
    },
    data() {
      return {
        model: this.value || '',
      }
    },
    directives: {
      upper: {
        update(el, bindings, node) {
          el.value = String(el.value).toUpperCase()
        },
      },
    },
    watch: {
      value(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      focus(newFocusValue, oldFocusValue) {
        if (oldFocusValue !== newFocusValue && this.$refs.input && this.focus) {
          this.$refs.input.focus()
        }
      },
    },
    methods: {
      handleOnChange() {
        if (this.model.length > 1) {
          this.model = this.model.slice(-1)
        }
        return this.$emit('on-change', this.model)
      },
      handleOnKeyDown(event) {
        const keyEvent = event
        const charCode = keyEvent.which ? keyEvent.which : keyEvent.keyCode
        if (/^[A-Za-z0-9]$/.test(keyEvent.key) || [8, 9, 13, 37, 39, 46, 86].includes(charCode)) {
          this.$emit('on-keydown', event)
        } else {
          keyEvent.preventDefault()
        }
      },
      handleOnPaste(event) {
        return this.$emit('on-paste', event)
      },
      handleOnFocus() {
        return this.$emit('on-focus')
      },
      handleOnBlur() {
        return this.$emit('on-blur')
      },
    },
    mounted() {
      if (this.$refs.input && this.focus && this.shouldAutoFocus) {
        this.$refs.input.focus()
      }
    },
  }
</script>
